import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { GeographicalRegion } from '../../../models/geographical-region.model';
import { SubGeographicalRegion } from '../../../models/sub-geographical-regions.model';

@Component({
  selector: 'lib-region-filter',
  templateUrl: './region-filter.component.html',
  styleUrl: './region-filter.component.scss',
  standalone: false
})
export class RegionFilterComponent implements OnChanges {
  @Input() regions: GeographicalRegion[] = [];
  @Input() allAreas: SubGeographicalRegion[] = [];
  @Input() selectedAreas: { id: number; name: string }[] = [];
  @Output() selectedAreasChange = new EventEmitter<{ id: number; name: string }[]>();

  areas: SubGeographicalRegion[] = [];
  regionSearchText: string = '';
  areaSearchText: string = '';
  selectedRegion: GeographicalRegion | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allAreas'] || changes['regions']) {
      this.updateAreas();
    }
  }

  get filteredRegions() {
    return this.regions.filter(
      (region) =>
        !this.regionSearchText ||
        region.name.toLowerCase().includes(this.regionSearchText.toLowerCase())
    );
  }

  selectRegion(region: GeographicalRegion) {
    this.selectedRegion = this.selectedRegion === region ? null : region;
    this.updateAreas();
  }

  getDistrictCount(region: GeographicalRegion): number {
    return this.allAreas.filter(area => area.geographicalRegion.id === region.id).length;
  }

  areAllAreasSelected(): boolean {
    if (this.areas.length === 0) return false;
    return this.areas.every(area => this.isAreaSelected({ id: area.id!, name: area.name }));
  }

  toggleSelectAllAreas() {
    if (this.areAllAreasSelected()) {
      const areaIds = this.areas.map(a => a.id!);
      this.selectedAreas = this.selectedAreas.filter(a => !areaIds.includes(a.id));
    } else {
      this.areas.forEach(area => {
        if (!this.isAreaSelected({ id: area.id!, name: area.name })) {
          this.selectedAreas.push({ id: area.id!, name: area.name });
        }
      });
    }
    this.emitSelectedAreas();
  }

  updateAreas() {
    this.areas = this.allAreas.filter(
      (area) =>
        (!this.selectedRegion || area.geographicalRegion.id === this.selectedRegion.id) &&
        (!this.areaSearchText ||
          area.name
            .toLowerCase()
            .includes(this.areaSearchText.toLowerCase()))
    );
  }

  isAreaSelected(area: { id: number; name: string }): boolean {
    return this.selectedAreas.some((a) => a.id === area.id);
  }

  onAreaSelect(area: { id: number; name: string }, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      this.selectedAreas.push(area);
    } else {
      this.selectedAreas = this.selectedAreas.filter((a) => a.id !== area.id);
    }
    this.emitSelectedAreas();
  }

  removeArea(area: { id: number; name: string }) {
    this.selectedAreas = this.selectedAreas.filter((a) => a.id !== area.id);
    this.emitSelectedAreas();
  }

  private emitSelectedAreas() {
    this.selectedAreasChange.emit([...this.selectedAreas]);
  }
}
